import * as core from "@twiage/core";
import * as utils from "@twiage/utils";
import { defineStore } from "pinia";
import { reactive, readonly, toRefs } from "vue";

import type { AuthenticationStoreState } from "../types/AuthenticationStoreState.js";
import type { Login } from "../types/Login.js";
import { login } from "./actions/login.js";
import { getInitialAuthenticationStoreState } from "./get-initial-authentication-store-state.js";

export const useAuthenticationStore = defineStore("authentication", () => {
  const state = reactive<AuthenticationStoreState>(
    getInitialAuthenticationStoreState(),
  );

  const user = core.getStoredAuthenticatedUser();

  if (user) {
    state.userTrackedPromise.resolve(user);
  }

  const actions = {
    login: utils.injectState<Login, AuthenticationStoreState>(login, state),
  };

  const logout = (): void => {
    core.logout();

    $reset();

    utils.mainEventBus.emit("Authentication.User.Logout_after");
  };

  const $reset = () =>
    Object.assign(state, getInitialAuthenticationStoreState());

  utils.mainEventBus.on("logout", logout);

  return {
    logout,
    ...actions,
    ...toRefs(readonly(state)),
  };
});
